import { useTranslation } from "react-i18next";
import { Tag } from "../Tag/Tag";
import { colorTagProps } from "./VehiclesTags/colorTagProps";
import "../../../../i18n/i18n";

export const TableTagBoolean = (props: { value: boolean }) => {
  const { t } = useTranslation();
  const color = props.value ? colorTagProps.success : colorTagProps.error;
  return (
    <Tag
      text={t(props.value ? "yesNoButton.yes" : "yesNoButton.no")}
      backgroundColor={color.backgroundColor}
      textColor={color.textColor}
      iconColor={color.iconColor}
    />
  );
};
